import { CONTACT_TYPE_SELECTED } from 'redux/modules/contact-us/actions/types';

import contactUs from './contactUs';

export default {
  [CONTACT_TYPE_SELECTED]: contactUs,
};
